// extracted by mini-css-extract-plugin
export default {"spinner":"spinner-mochi_spinner__W22jU","placeHolderShimmer":"spinner-mochi_placeHolderShimmer__S4MX3"};